import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NotificationSlide from '../components/NotificationSlide';
import ContractViewer from '../components/ContractViewer';
import HeaderComponent from '../components/HeaderComponent';
import { resolveHomeRoute } from '../data/onboardingConfig';
import { PlayVideoIcon } from '../components/shared/Icons';
import VideoPlayer from '../components/VideoPlayer';



import {
  ServerIcon,
  IdentificationIcon,
  UsersIcon,
  UserIcon,
  BuildingOfficeIcon,
  EnvelopeIcon,
  DocumentIcon,
  XMarkIcon
} from "@heroicons/react/24/outline";



let myDataTransfer = [];

const allItems = [
  {
    id: "snlprofileform",
    title: "SNL profile",
    description: "Create your Profile.",
    icon: ServerIcon,
    background: "bg-pink-500",
    link: "/snldatabaseform",
    availableFor: ["Employee","Sole Trader", "Partnership", "Company"],
  },
  {
    id: "employment",
    title: "Employee",
    description: "Create your Employee contract.",
    icon: IdentificationIcon,
    background: "bg-yellow-500",
    link: '/contract',
    availableFor: ["Employee"],
  },
  {
    id: "declinetfn",
    title: "Decline TFN",
    description: "Create your Decline TFN agreement.",
    icon: UserIcon,
    background: "bg-purple-500",
    link: "/contract",
    availableFor: ["Sole Trader", "Partnership", "Company"],
  },
  {
    id: "soletrader",
    title: "Sole Trader",
    description: "Create your Sole Trader agreement.",
    icon: UserIcon,
    background: "bg-blue-500",
    link: "/contract",
    availableFor: ["Sole Trader"],
  },
  {
    id: "partnership",
    title: "Partnership",
    description: "Create your Partnership agreement.",
    icon: UsersIcon,
    background: "bg-green-500",
    link: "/contract",
    availableFor: ["Partnership"],
  },
  {
    id: "company",
    title: "Company",
    description: "Create your Company agreement.",
    icon: BuildingOfficeIcon,
    background: "bg-indigo-500",
    link: "/contract",
    availableFor: ["Company"],
  },
  {
    id: "documentupload",
    title: "Document Uploads",
    description: "Upload your documents.",
    icon: DocumentIcon,
    background: "bg-gray-500",
    link: "/documentforms",
    availableFor: ["Employee","Sole Trader", "Partnership", "Company"],
  },
  {
    id: "helpuser",
    title: "View help pdf",
    description: "Read first if your unsure.",
    icon: EnvelopeIcon,
    background: "bg-gray-500",
    link: "/pdf",
    availableFor: ["Employee","Sole Trader", "Partnership", "Company"],
  },
];





function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MyProfilePage = () => {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const userType = !Array.isArray(locationState) 
    ? locationState?.userType || 'Existing' 
    : 'Existing';
  // Separate state variables
    const [showVideo, setShowVideo] = useState(false);

    const HUB_VIDEO = {
      url: 'https://youtu.be/nfipkklavuI',
      title: 'Onboarding-process',
    };
  const [myName, setMyName] = useState('');
  // eslint-disable-next-line
  const [myEmail, setMyEmail] = useState('');
  // eslint-disable-next-line
  const [myMobile, setMyMobile] = useState('');
  
  const [myEmploymentType, setMyEmploymentType] = useState('');
  const [snlEmploymentType, setSnlEmploymentType] = useState('');
  // eslint-disable-next-line
  const [recordA, setRecordA] = useState([]);
  // eslint-disable-next-line
  const [recordB, setRecordB] = useState([]);
  
  const [primaryContracts, setPrimaryContracts] = useState([]);
  const [secondaryContracts, setSecondaryContracts] = useState([]);
  const [nextComplete, setNextComplete] = useState('');
  
  const [myNextHelper, setMyNextHelper] = useState('');
  const [recid, setRecid] = useState([]);
  const [displayEmploymentType, setDisplayEmploymentType] = useState([])
  const [displayEmploymentStatus, setDisplayEmploymentStatus] = useState([])
  const [navBarEmploymentStatus, setNavBarEmploymentStatus] = useState('')
  const [stillNewSecondary, setStillNewSecondary] = useState([])
  const [stillNewPrimary, setStillNewPrimary] = useState([])
  const [newSecondary, setNewSecondary] = useState([])
  const [newPrimary, setNewPrimary] = useState([])
  const [showTfnAbnModal, setShowTfnAbnModal] = useState(false);
  const [showHelpPdf, setShowHelpPdf] = useState(false);
  
  
  useEffect(() => {
  const controller = new AbortController();
  setLoading(true);
  
  const fetchProfileData = async () => {
    try {
      // First check if we have data from navigation state
      if (locationState?.data) {
        setProfileData(locationState.data);
        setLoading(false);
        return;
      }

      
      const response = await fetch('/api/validate-login-user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        signal: controller.signal
      });

      if (!response.ok) throw new Error('Failed to fetch profile data');
      
      const data = await response.json();
      
      if (!data) throw new Error('No data received');
      
      setProfileData(data);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Failed to fetch profile data:', error);
      }
    } finally {
      if (!controller.signal.aborted) {
        setLoading(false);
      }
    }
  };

  fetchProfileData();
  
  return () => controller.abort();
}, [locationState]);



  useEffect(() => {
    if (!profileData) return;
      
      setMyName(profileData[4] || "");
      setMyEmail(profileData[2] || "");
      setMyMobile(profileData[3] || "");
      const primarySnlHireFor = profileData[1] || "";
      const secondarySnlHireFor = profileData[17] || "";
      const primaryRecid = profileData[0] || "";
      const secondaryRecid = profileData[16] || "";
      const primaryType = profileData[5] || "";
      const secondaryType = profileData[21] || "";
      const primaryStatus = profileData[6] || "";
      const secondaryStatus = profileData[22] || "";
      const primaryNext = profileData[14] || "";
      const secondaryNext = profileData[30] || "";
      const primaryNextHelper = profileData[15] || "";
      const secondaryNextHelper = profileData[31] || "";

      // form and contracts status
      const primarySnlform = profileData[7] || "";
      const secondarySnlform = profileData[23] || "";
      const primaryEmployeeContract = profileData[8] || "";
      const secondaryEmployeeContract = profileData[24] || "";
      const primarySoletraderContract = profileData[9] || "";
      const secondarySoletraderContract = profileData[25] || "";
      const primaryDeclineContract = profileData[10] || "";
      const secondaryDeclineContract = profileData[26] || "";
      const primaryPartnershipContract = profileData[11] || "";
      const secondaryPartnershipContract = profileData[27] || "";
      const primaryCompanyContract = profileData[12] || "";
      const secondaryCompanyContract = profileData[28] || "";
      
      
      
      setMyEmploymentType (
        primaryType && secondaryType ? [primaryType , secondaryType] : primaryType
        );
      
      setNextComplete (
        primaryNext && secondaryNext ? [primaryNext , secondaryNext] : primaryNext
        );
      setMyNextHelper (
        primaryNextHelper && secondaryNextHelper ? [primaryNextHelper , secondaryNextHelper] : primaryNextHelper
        );
     

      setPrimaryContracts ( [primarySnlform, primaryEmployeeContract, primarySoletraderContract, primaryDeclineContract, primaryPartnershipContract, primaryCompanyContract] );

      if (secondarySnlform || secondaryEmployeeContract || secondarySoletraderContract || 
      secondaryDeclineContract || secondaryPartnershipContract || secondaryCompanyContract) {
    setSecondaryContracts([
      secondarySnlform, 
      secondaryEmployeeContract, 
      secondarySoletraderContract, 
      secondaryDeclineContract, 
      secondaryPartnershipContract, 
      secondaryCompanyContract
    ]);
  }
      
      setDisplayEmploymentType (
        primaryType && secondaryType ? `${primaryType} and ${secondaryType}` : `${primaryType}`
        );
         
      setDisplayEmploymentStatus (
        primaryStatus && secondaryStatus ? `${primaryStatus} / ${secondaryStatus}` : `${primaryStatus}`
        );
      

      setNavBarEmploymentStatus (
        primaryStatus && secondaryStatus ? `TFN and ABN` : `${primaryStatus}`
        );

      setSnlEmploymentType (
        primarySnlHireFor && secondarySnlHireFor ? `${primarySnlHireFor}` : `${primarySnlHireFor}`
        );
      
       // Process record data
  const recordA1 = [];
  const recordB1 = [];
  
  // Fill recordA1 with first 16 elements
  for (let i = 0; i < 16; i++) {
    recordA1.push(profileData[i] || "");
  }
  
  // Fill recordB1 with elements 16-31 if they exist
  for (let i = 16; i < 32; i++) {
    if (profileData[i] !== undefined) {
      recordB1.push(profileData[i]);
    }
  }
  
  // Set record states
  setRecordA(recordA1);
  if (recordB1.length > 0) {
    setRecordB(recordB1);
  }
  
  // Set recid based on whether we have secondary data
  if (primaryRecid && secondaryRecid) {
    setRecid([recordA1, recordB1]);
  } else {
    setRecid(recordA1);
  }
    
}, [profileData]);
 


useEffect(() => {

  const allContracts = ["snlprofileform", "employment", "soletrader", "declinetfn", "partnership", "company"];
        const newPrimary = primaryContracts
            .map((element, index) => element === "New" ? index : -1)
            .filter(index => index !== -1);

      const newSecondary = secondaryContracts
            .map((element, index) => element === "New" ? index : -1)
            .filter(index => index !== -1);
      setNewPrimary(newPrimary);
      setNewSecondary(newSecondary);
        setStillNewPrimary(newPrimary
          .filter(index => index < allContracts.length)
          .map(index => allContracts[index]));
            
        setStillNewSecondary(newSecondary
          .filter(index => index < allContracts.length)
          .map(index => allContracts[index]));



      },[primaryContracts,secondaryContracts]);


  const visibleItems = useMemo(() => {
  return allItems.map((item) => ({
    ...item,
    isEnabled: Array.isArray(myEmploymentType) 
      ? myEmploymentType.some(type => item.availableFor.includes(type))
      : item.availableFor.includes(myEmploymentType),
      }));
    }, [myEmploymentType]);
  
  
  // Loading state
  if (loading) {
    return <div className="flex justify-center items-center h-screen">
      <p>Loading onboarding central hub...</p>
    </div>;
  }





const getContractStatus = (itemId) => {
  const allContracts = ["snlprofileform", "employment", "soletrader", "declinetfn", "partnership", "company"];
  const contractPrimary = newPrimary
    .filter(index => index < allContracts.length)
    .map(index => allContracts[index])
    .find(value => value === itemId) ?? -1;
    
  const contractSecondary = newSecondary
    .filter(index => index < allContracts.length)
    .map(index => allContracts[index])
    .find(value => value === itemId) ?? -1;
    
  return { contractPrimary, contractSecondary };
};

const handleItemClick = (e, item) => {
  const allContracts = ["snlprofileform", "employment", "soletrader", "declinetfn", "partnership", "company"];
  e.preventDefault();
  
  // Initial validation
  
  const isContractForm = allContracts.includes(item.id);
  
  if (!item.isEnabled) {
    alert(`This option is only registered for ${item.availableFor.join(", ")} status`);
    return;
  }
  
  const { contractPrimary, contractSecondary } = getContractStatus(item.id);
  
  // Handle contract form validation
  if (isContractForm) {
    // Case: User has dual employment types (nextComplete is array)
    if (Array.isArray(nextComplete)) {
      // Case: Both records are completed
      if (nextComplete[0] === "Completed" && nextComplete[1] === "Completed") {
        alert("You have completed all your requirements, well done!");
        return;
      }
      
      // Case: Primary record validation
      if (nextComplete[0] !== "Completed") {
        if (nextComplete[0] !== item.id) {
          // Special message if this form has "New" status but isn't next in sequence
          if (contractPrimary === item.id) {
            alert(`You will have to complete ${item.title} contract, but for now you are required to complete ${myNextHelper[0]} next.`);
          } else {
            alert(`You can't do ${item.title} yet, you must complete ${myNextHelper[0]} next.`);
          }
          return;
        }
      }
      
      // Case: Secondary record validation (only if primary is completed)
      if (nextComplete[0] === "Completed" && nextComplete[1] !== "Completed") {
        if (nextComplete[1] !== item.id) {
          // Special message if this form has "New" status but isn't next in sequence
          if (contractSecondary === item.id) {
            alert(`You will have to complete ${item.title} contract, but for now you are required to complete ${myNextHelper[1]} next.`);
          } else {
            alert(`You can't do ${item.title} yet, you must complete ${myNextHelper[1]} next.`);
          }
          return;
        }
      }
    } 
    // Case: User has single employment type
    else {
      if (nextComplete === "Completed") {
        alert("You have completed all your requirements, well done!");
        return;
      }
      
      if (nextComplete !== item.id) {
        // Special message if this form has "New" status but isn't next in sequence
        if (contractPrimary === item.id) {
          alert(`You will have to complete ${item.title} contract, but for now you are required to complete ${myNextHelper} next.`);
        } else {
          alert(`You can't do ${item.title} yet, you must complete ${myNextHelper} next.`);
        }
        return;
      }
    }
  }
  myDataTransfer = [];
  // Navigation logic (only reached if all validations pass)
  
 if (item.id === "helpuser") {
    if (showHelpPdf) {
      setShowHelpPdf(false);
    } else {
      setShowHelpPdf(true);
    }
    
    return;
  } else {
    myDataTransfer = processRecordId(item.id);
  }

 if (item.id === "documentupload" && Array.isArray(recid) && recid.length === 2) {
    // The modal will be shown by processRecordId
    return;
  }

  if (item.link !== "#" && item.id !== "helpuser") {
    
      
      navigate(item.link, { 
            state: { 
              data: myDataTransfer,
              userType,
            }
          });

    
    
  }
};



  



  const processRecordId = (item) => {
  const allForms = {7: "snlprofileform", 8: "employment", 9: "soletrader", 10: "declinetfn", 11: "partnership", 12: "company"};
  
  if (item ==="documentupload" ) {
    if (recordB.length > 0) {
      // Open the modal instead of navigating immediately
      setShowTfnAbnModal(true);
      return null;
    } else {
      return recid[0];
    }
  
  } else if (Array.isArray(nextComplete)) {
    
    const nextHelper = nextComplete[0] !== "Completed" ? nextComplete[0] : nextComplete[1];
    const formKey = Object.keys(allForms).find(
      key => allForms[key] === nextHelper
    );
    
    
    if (!formKey) return recid;
    const numericKey = parseInt(formKey, 10);
    
    
    
    
      const firstStatus = recid[0][numericKey];
      const secondStatus = recid[1][numericKey];
      
      
      if (firstStatus === "New") {
       
        return recid[0];
      } else if (secondStatus === "New") {
       
        return recid[1];
      } else {
        
        return recid;
      }
    
  } else {
    
    return recid;
  }
  
  
  
};
const homeRoute = resolveHomeRoute(userType);
 const handleRecordTypeSelect = (recordType) => {
  
  setShowTfnAbnModal(false);
  
  // Navigate to document upload with the selected record
  const selectedRecord = recordType === recordA[6] ? recid[0][0] : recid[1][0];
  navigate("/documentforms", { 
        state: { 
          data: selectedRecord,
          userType,
        }
      });
      };

          
  return (
     <>
     <HeaderComponent
        title="Onboarding Hub"
        backRoute={homeRoute}
        backLabel="Back to Home"
      /> 
      
   {/* Outer: full-width background, 50px gap from header */}
    <div 
      className="min-h-screen w-full pt-[50px] pb-[50px] px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: "#1a1a2e" }}
    >
      {/* Inner: the white card, capped at 850px and centered */}
      <div 
        style={{
          width: "100%",
          maxWidth: "850px",
          margin: "0 auto",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(5px)",
          borderRadius: "16px",
          padding: "40px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2 className="text-base font-semibold text-blue-900">
          Welcome {myName}, to SNL Commercial Property Services onboarding central hub.
        </h2>
        <p className="mt-1 text-sm text-gray-800 flex items-center gap-2 flex-wrap">
          <span>
            You employment status is registered as, {displayEmploymentStatus} and
            your services will be rendered as {displayEmploymentType}.
          </span>
          <button
            onClick={() => setShowVideo(true)}
            className="inline-flex items-center shrink-0 focus:outline-none"
            title={HUB_VIDEO.title}
            style={{ stroke: '#1e3a8a' }}
            aria-label={`Watch ${HUB_VIDEO.title} video`}
          >
            <PlayVideoIcon />
          </button>
        </p>

        <style>{`
          .notification-slide {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            transform: translateY(-50px);
            transition: transform 0.3s cubic-bezier(.29,.67,.83,.5);
            will-change: transform;
            z-index: 20;
          }
          
          @media (hover: hover) and (pointer: fine) {
            .item-card:hover .notification-slide {
              transform: translateY(0);
            }
          }
        `}</style>

          <ul className="mt-4 grid grid-cols-1 sm:grid-cols-1 gap-1 lg:grid-cols-2 w-auto border-b border-t border-gray-600">
          {visibleItems.map((item, itemIdx) => {
            // Get contract status for each item
            const { contractPrimary, contractSecondary } = getContractStatus(item.id);
            
            return (
              <li key={itemIdx} className="flow-root py-2">
                <div className="relative flex items-center space-x-2 space-y-2 card h-20 rounded-lg focus-within:ring-2 focus-within:ring-indigo-500 hover:bg-gray-50 item-card overflow-hidden">
                  {/* Notification slide with contract status */}
               
                  <NotificationSlide
                    item={item} 
                    nextComplete={nextComplete} 
                    myNextHelper={myNextHelper} 
                    stillNewPrimary={stillNewPrimary} 
                    stillNewSecondary={stillNewSecondary}
                    contractPrimary={contractPrimary}
                    contractSecondary={contractSecondary}
                    showHelpPdf={showHelpPdf}
                  />
               
                  <div
                    className={classNames(
                      item.background,
                      "flex size-16 shrink-0 mt-2 items-center justify-center rounded-lg"
                    )}
                  >
                    <item.icon
                      aria-hidden="true"
                      className="h-12 w-12 text-white"
                    />
                  </div>
                  <div className="flex-2">
                    <h3 className="text-sm text-gray-900">
                      <a href={item.isEnabled ? item.link : "#"}
                        className="focus:outline-none"
                        onClick={(e) => handleItemClick(e, item)}
                      >
                        <span aria-hidden="true" className="absolute inset-0" />
                        <span>{item.id === "helpuser" && showHelpPdf ? "Click to close help PDF." : item.title}</span>
                        <span aria-hidden="true"> &rarr;</span>
                      </a>
                    </h3>
                    <p className="mt-1 text-sm text-gray-600">
                      {item.id === "helpuser" && showHelpPdf ? "Click to close help PDF." : item.description}
                    </p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
    {showTfnAbnModal && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Select Record Type</h3>
      <p className="mb-4 text-gray-600">You have both TFN and ABN records. Which one would you like to upload documents for?</p>
      
      <div className="flex flex-col space-y-3">
        <button
          onClick={() => handleRecordTypeSelect('TFN')}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
        >
          TFN (Tax File Number)
        </button>
        
        <button
          onClick={() => handleRecordTypeSelect('ABN')}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
          ABN (Australian Business Number)
        </button>
        
        <button
          onClick={() => setShowTfnAbnModal(false)}
          className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)} 

    {showVideo && (
  <div
    className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4 pt-16"
    onClick={() => setShowVideo(false)}
  >
    <div
      className="bg-gray-900 rounded-2xl shadow-2xl overflow-hidden w-full md:w-[65vw] max-w-[1200px]"
      style={{ border: '1px solid #22d3ee' }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-4 py-3">
        <h3 className="text-lg font-semibold text-white">
          {HUB_VIDEO.title}
        </h3>
        <button
          onClick={() => setShowVideo(false)}
          className="text-gray-400 hover:text-white focus:outline-none"
          aria-label="Close video"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      <div className="w-full" style={{ aspectRatio: '16 / 9', maxHeight: '75vh' }}>
        <VideoPlayer
          url={HUB_VIDEO.url}
          title={HUB_VIDEO.title}
          autoPlay
          muted={false}
        />
      </div>
    </div>
  </div>
)}
{showHelpPdf && (
      <div style={{ paddingBottom: 24, marginTop: 24 }}>  
                
      <ContractViewer
          pdfUrl="/static/pdffilters/SNL_Onboarding_Hub_Help.pdf"
          onClose={() => setShowHelpPdf(false)}
                />
    </div>
    )}

</>
    
  );
};


export default MyProfilePage;